<template>
    <div>
        <div class="vx-row mb-base">
            <vx-card class="w-full ml-4 mr-4">
                <div class="vx-row ml-1">
                    <div class="vx-col sm:w-full md:w-4/12 lg:w-3/12 xl:w-3/12 w-full mb-4 ">
                        <span class="vx-col">Data inicial</span>
                        <datepicker :highlighted="highlightedFn" format="d de MMMM de yyyy" :language="languages['ptBR']" v-model="date.from"></datepicker>
                    </div>
                    <div class="vx-col sm:w-full md:w-4/12 lg:w-3/12 xl:w-3/12 w-full mb-4 ">
                        <span class="vx-col">Data final</span>
                        <datepicker :highlighted="highlightedFn" format="d de MMMM de yyyy" :language="languages['ptBR']" v-model="date.to"></datepicker>
                    </div>
                    <div class="vx-col sm:w-full md:w-3/12 lg:w-2/12 xl:w-2/12 w-full">
                        <vs-button  type="relief" class="w-full mt-6"  @click="getPaymentData()"> <a-icon type="filter" /> Filtrar</vs-button>
                    </div>
                </div>
            </vx-card>
        </div>

        <div class="vx-row" v-if="dataByPeriod.length == 0">
            <h4 class="w-full text-center"> Não há dados </h4>
        </div>
        <div v-else class="vx-row">

            <statistics-line-card-payment class="vx-col w-full mb-4" :paymentData="dataByPeriod" />
            
            <!-- ESTE COMPONENTE ESTÁ PREDUJUDICANDO O WIDTH DO COMPONENTE ACIMA -->
            <statistics-pie-card-products class="vx-col xl:w-6/12 w-full mb-4" :productsData="dataByPeriod" />
        </div>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import Datepicker from 'vuejs-datepicker'
    import * as lang from 'vuejs-datepicker/src/locale'
    import StatisticsLineCardPayment from '@/components/statistics-cards/period/StatisticsLineCardPayment'
    import StatisticsPieCardProducts from '@/components/statistics-cards/period/StatisticsPieCardProducts'

    export default {
        components : {
            Datepicker,
            StatisticsLineCardPayment,
            StatisticsPieCardProducts
        },

        data () {
            return {
                languages: lang,
                date : {
                    from : '',
                    to : ''
                },
                highlightedFn : {
                    customPredictor(date) {
                        let today = new Date()
                        if (date.getDate() == today.getDate() && date.getMonth() == today.getMonth()) {
                            return true;
                        }
                    }
                },
                dataByPeriod : []
            }
        },

        methods : {
            async getPaymentData () {
                if(this.date.from == '' || this.date.to == '') return

                if (new Date(this.date.from) >= new Date(this.date.to)) {
                    this.$warning({
                        zIndex: 99999,
                        title: 'Corrija os erros',
                        content: 'A data de início deve ser menor que a data final!'
                    })
                    return
                }

                this.clearPaymentData()

                let date = this.getFormatedDate()

                let companyId = this.$store.getters.getCompanyID
                let ref = firebase.firestore().collection(`/company/${companyId}/counters/closing/daily`)

                try {
                    this.$vs.loading()

                    let payments = await ref
                        .where('date', '>=', date.fromDate)
                        .where('date', '<=', date.toDate)
                        .get()

                    this.dataByPeriod = payments.docs
                } catch (err) {
                    this.$error({
                        zIndex: 99999,
                        title: 'Erro!',
                        content: err.message
                    })
                } finally {
                    this.$vs.loading.close()
                }                
            },

            getFormatedDate () {
                let fromDate = new Date(this.date.from)
                fromDate.setHours(0)
                fromDate.setMinutes(0)
                fromDate.setSeconds(0)

                let toDate = new Date(this.date.to)
                toDate.setHours(59)
                toDate.setMinutes(59)
                toDate.setSeconds(59)
                return { fromDate: fromDate, toDate : toDate }
            },

            clearPaymentData () {
                this.dataByPeriod = []
            }
        }
    }
</script>